export const AUTOMATIC = "__auto__";
export function format_number(number, locale = AUTOMATIC, options = {}) {
    if (typeof number !== "number")
        return "" + number;
    if (locale === AUTOMATIC) {
        locale = document.documentElement.lang;
    }
    return Intl.NumberFormat(locale, options).format(number);
}
